import React from "react"

import "./horizontal-content-row.sass"

const HorizontalContentRow = ({ children }) => {
  return <div className={"_fp-horizontal-content-row"}>{children}</div>
}

export default HorizontalContentRow
